import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getInvoiceById } from "../../../../services/billing";
import { useBilling } from "../../../../context/BillingContext";
import DescriptionList from "../../../../common/DescriptionList";
import formatDate from "../../../../common/DateFormate";
import { logo } from "../../../../../images";
import { getBrandName } from "../../../StaticPages/Components/getBrandName";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";

const ShowBillingPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const { id } = useParams();
  const { brandName, normalizedBrand,mail,phone ,address} = getBrandName();
  const { currentPlan, paymentMethods } = useBilling();
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setIsLoading(true);
        const apiRes = await getInvoiceById(id);
        setInvoice(apiRes.data.data);
      } catch (err) {
        console.error("Failed fetch perticullar invoice API :", err);
      } finally {
        setIsLoading(false);
      }
    };
    id && fetchInvoice();
  }, [id]);

  const handleDownloadInvoice = async (invoiceId) => {
    setIsLoading(true);
    // const invoice = invoice?.attributes?.find((bill) => bill.invoice === invoiceId)
    // if (!invoice) {
    //   setIsLoading(false)
    //   return
    // }

    try {
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        setIsLoading(false);
        return;
      }

      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>Invoice ${invoice?.attributes?.invoice_number}</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
            .invoice-header { border-bottom: 3px solid #007bff; padding-bottom: 20px; margin-bottom: 30px; }
            .company-info { color: #007bff; }
            .invoice-details { background: #f8f9fa; }
            @media print { body { margin: 0; } }
            .payment-info {
              background: #f9fafb;
              border-radius: 8px;
              margin-top: 20px;
            }
            .text-color{
            color:#362BDF;
              }
            .payment-info h3 {
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 12px;
              color: #1f2937;
            }
            .payment-info p {
              color: #6b7280;
              font-size: 14px;
              margin-bottom: 4px;
            }
          </style>
        </head>
        <body class="p-4">
          <div class="container">
            <div class="invoice-header d-flex justify-content-between align-items-start">
              <div>
                <img src=${logo} alt="Gapalyze" class="mb-1 mt-4" style="width:180px; height:auto; margin-left:0px;"/>
                <p class="text-muted mb-0 mt-0">Professional Billing Solutions</p>
              </div>
              <div class="text-end mt-4">
                <h2 class="text-color mb-1">INVOICE</h2>
                <p class="mb-1"><strong>${
                  invoice?.attributes?.invoice_number || ""
                }</strong></p>
                <p class="text-muted mb-0">Date: ${formatDate(invoice?.attributes?.created_at || "")}</p>
              </div>
            </div>
            
            <div class="row mb-4">
              <div class="col-md-6">
                <h5 class="text-color mb-3">Bill To:</h5>
                <div class="invoice-details">
                  <p class="mb-1 text-capitalize"><strong>${
                    invoice?.attributes?.details?.attributes?.customer_details
                      ?.name || ""
                  }</strong></p>
                  <p class="mb-1">${
                    invoice?.attributes?.details?.attributes?.customer_details
                      ?.email || ""
                  }</p>
                  <p class="mb-1">${
                    invoice?.attributes?.details?.attributes?.customer_details
                      ?.billing_address || ""
                  }</p>
                  <p class="mb-1">${
                    invoice?.attributes?.details?.attributes?.customer_details
                      ?.contact || ""
                  }</p>
                </div>
              </div>
              <div class="col-md-6">
                <h5 class="text-color mb-3">Invoice Details:</h5>
                <div class="invoice-details">
                  <div class="d-flex justify-content-between mb-2">
                    <span>Invoice Date:</span>
                    <span>
                    ${formatDate(invoice?.attributes?.created_at || "")}
                    </span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span>Due Date:</span>
                    <span>${formatDate(invoice?.attributes?.due_at || "")}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span>Billing Period:</span>
                    <span>${formatDate(invoice?.attributes?.billing_start_at || "")} To ${formatDate(invoice?.attributes?.billing_end_at || "")}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>Payment Method:</span>
                    <span class="text-capitalize">${invoice?.attributes?.payment_method || ""}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-4">
              <table class="table table-striped">
                  <tr>
                    <th>Description</th>
                    <th class="text-center">Quantity</th>
                    <th class="text-end">Unit Price</th>
                    <th class="text-end">Total</th>
                  </tr>
              <tbody>
                ${(invoice?.attributes?.items || [])
                  .map(
                    (item) => `
                      <tr>
                        <td>${<DescriptionList description={currentPlan?.description||""} />}</td>
                        <td class="text-center">${item?.quantity || ""}</td>

                        <td class="text-end">${item?.unitPrice || ""}</td>
                        <td class="text-end">${item?.total || ""}</td>
                      </tr>
                    `
                  )
                  .join("")}
              </tbody>

              </table>
            </div>

            <div class="row">
              <div class="col-md-6 offset-md-6">
                <div class="total-section">
                  <div class="d-flex justify-content-between mb-2">
                    <span>Subtotal:</span>

                    <span>${invoice?.attributes?.details?.attributes?.currency_symbol || ""}${invoice?.attributes?.amount || ""}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span>Tax:</span>
                    <span>${invoice?.attributes?.details?.attributes?.currency_symbol || ""}${
                      invoice?.attributes?.details?.attributes?.tax_amount || "0"
                    }</span>
                  </div>
                  <hr class="border-light"><hr />
                  <div class="d-flex justify-content-between">
                    <strong>Total:</strong>
                    <strong>${invoice?.attributes?.details?.attributes?.currency_symbol||""}${invoice?.attributes?.amount || ""}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="payment-info">
              <h3>Payment Terms & Notes</h3>
              <p>Thank you for your business! This invoice is automatically generated and processed.</p>
              <p>For any questions regarding this invoice, please contact our support team.</p>
            </div>
          </div>
        </body>
        </html>
      `;

      printWindow.document.write(htmlContent);
      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    } catch (error) {
      console.error("Error generating invoice:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRetryPayment = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsLoading(false);
    alert("Retry payment triggered!");
  };

  return (
    <>
      <div className='without-datepicker-breadcrumb'>
        <Breadcrumb 
            categoryName={invoice?.attributes?.invoice_number}
            categoryId={id}
            componentType={"invoiceHistory"}
        />
      </div>
      <section className="container-fluid p-0 mt-2">
        {/* Header */}

        <div className="row g-4">
          {/* Left Content */}
          <div className="col-lg-8">
            {/* Invoice Header Card */}
            <div className="card shadow-sm mb-4">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      {invoice?.attributes?.invoice}
                    </h5>
                    {currentPlan?.name && (
                    <p className="card-text text-muted mb-0">
                      Plan Name - {currentPlan?.name}
                    </p>
                    )}
                  </div>
                  <span
                  className={`badge px-3 py-2 fs-6 text-capitalize ${
                    invoice?.attributes?.status === "failed"
                      ? "btn-danger-light"
                      : invoice?.attributes?.status === "issued" ? "payment-status" : "payment-paid"
                  }`}
                >
                {invoice?.attributes?.status}
                </span>
                </div>
              </div>
              <div className="card-body h-auto row">
                <div className="col-md-4">
                  <strong>Issue Date:</strong>

                  <p>{formatDate(invoice?.attributes?.billing_start_at)||""}</p>

                </div>
                <div className="col-md-4">
                  <strong>Due Date:</strong>
                   <p>{formatDate(invoice?.attributes?.due_at)||""}</p>
                </div>
                {invoice?.attributes?.paid_at && (
                <div className="col-md-4">
                  <strong>Payment Date:</strong>
                  <p>{formatDate(invoice?.attributes?.paid_at)||""}</p>
                </div>
                )}
                <hr />
                <div className="col-md-6">
                  <strong>Billing Period:</strong>
                  <p>

                    {formatDate(invoice?.attributes?.billing_start_at)||""}
                    {" "}To{" "}
                    {formatDate(invoice?.attributes?.billing_end_at)||""}
                  </p>
                </div>
                <div className="col-md-6">
                  <strong>Payment Method:</strong>
                  <p>
                   <span class="text-capitalize">{invoice?.attributes?.payment_method}</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Company & Billing Info */}
            <div className="row g-3">
              <div className={invoice?.attributes?.details?.attributes
                  ?.customer_details ? "col-md-6" : "col-md-12"}>
                <div className="card h-100 shadow-sm">
                  <div className="card-header h-auto bg-transparent">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="card-title mb-1 card-title-custom">
                          From
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body h-auto">
                    <h6>
                      {invoice?.attributes?.companyInfo?.name ||
                        brandName + " Private Limited"}
                    </h6>
                    <p className="mb-1">
                      {invoice?.attributes?.companyInfo?.address ||
                        address}
                    </p>
                    {/* <p>
                      {invoice?.attributes?.companyInfo?.city}, {invoice?.attributes?.companyInfo?.state}{" "}
                      {invoice?.attributes?.companyInfo?.zip}
                    </p> */}
                    <p>{invoice?.attributes?.companyInfo?.country}</p>
                    <hr />
                    {mail && (
                    
                    <p className="mb-1">
                      <i className="bi bi-envelope"></i>{" "}
                      <a href={"mailto:"+ mail}>{invoice?.attributes?.companyInfo?.email ||
                        mail}</a>
                    </p>
                    ) }
                    {phone && (
                    <p>
                      <i className="bi bi-telephone"></i>{" "}
                      <a href={"tel:"+ phone}>
                      {invoice?.attributes?.companyInfo?.phone ||
                        phone}
                      </a>
                    </p>
                    )}
                  </div>
                </div>
              </div>
              {  invoice?.attributes?.details?.attributes
                  ?.customer_details && (
              <div className="col-md-6">
                <div className="card h-100 shadow-sm">
                  <div className="card-header h-auto bg-transparent">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="card-title mb-1 card-title-custom">
                          To
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body h-auto">
                    <h6 className="text-capitalize">
                      {
                        invoice?.attributes?.details?.attributes
                          ?.customer_details?.name
                      }
                    </h6>
                    <p className="mb-1">
                      {invoice?.attributes?.details?.attributes
                        ?.customer_details?.billing_address || " "}
                    </p>
                    <p>
                      {/* {invoice?.attributes?.billingAddress?.city},{" "} */}
                      {/* {invoice?.attributes?.billingAddress?.state} {invoice?.attributes?.billingAddress?.zip} */}
                    </p>
                    {/* <p>{invoice?.attributes?.billingAddress?.country}</p> */}
                    <hr />
                    {invoice?.attributes?.details?.attributes?.customer_details?.email && (
                    <p className="mb-1">
                      <i className="bi bi-envelope"></i>{" "}
                      <a href={"mailto:"+ invoice?.attributes?.details?.attributes
                          ?.customer_details?.email}>{
                        invoice?.attributes?.details?.attributes
                          ?.customer_details?.email
                      }</a>
                    </p>
                    )}
                    {/* <p className="mb-1">📧 {invoice?.attributes?.billingAddress?.email}</p> */}
                    {invoice?.attributes?.details?.attributes?.customer_details?.contact && (
                    <p>
                      <i className="bi bi-telephone"></i>{" "}
                      <a href={"tel:"+ invoice?.attributes?.details?.attributes
                          ?.customer_details?.contact}>
                      {
                        invoice?.attributes?.details?.attributes?.customer_details?.contact
                      }
                      </a>
                    </p>
                    )}
                  </div>
                </div>
              </div>
              )}
            </div>

            {/* Invoice Items */}
            {/* <div className="card shadow-sm">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Invoice Items
                    </h5>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Description</th>
                      <th className="text-center">Qty</th>
                      <th className="text-end">Unit Price</th>
                      <th className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.attributes?.items.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-muted">{item?.description}</td>
                        <td className="text-center text-muted">{item?.quantity}</td>
                        <td className="text-end text-muted">${item?.unitPrice}</td>
                        <td className="text-end text-muted fw-bold">${item?.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>*/}
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4">
            {/* Payment Summary */}
            <div className="card shadow-sm mb-3">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Payment Summary
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto">
                <div className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <span>{invoice?.attributes?.details?.attributes?.currency_symbol || ""}{invoice?.attributes?.amount}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Tax:</span>
                  <span>
                    {invoice?.attributes?.details?.attributes?.currency_symbol||""}{invoice?.attributes?.details?.attributes?.tax_amount}
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between fw-bold">
                  <span>Total:</span>
                  <span className="text-color">
                   {invoice?.attributes?.details?.attributes?.currency_symbol||""}{invoice?.attributes?.amount}
                  </span>
                </div>
              </div>
            </div>

            {/* Payment Method */}
            {/* <div className="card shadow-sm mb-3">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Payment Method
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto">
                <div className="p-2 border rounded">
                  <p className="mb-1">
                    Card ending in {paymentMethods?.id}
                  </p>
                  <small className="text-muted">
                    Payment {invoice?.attributes?.status}
                  </small>
                </div>
              </div>
            </div> */}

            {/* Actions */}
            <div className="card shadow-sm">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Action
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto d-grid gap-2">
                <button
                  className="btn plan-detail-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadInvoice("1");
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "⬇ Download PDF"}
                </button>
                {invoice?.attributes?.status === "failed" && (
                  <button
                    className="btn btn-outline-danger"
                    onClick={handleRetryPayment}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "↻ Retry Payment"}
                  </button>
                )}
                {/* <button className="btn btn-light">← Back to Billing</button> */}
                {/* <Link
                  className="btn btn-outline-secondary btn-sm me-3 mb-2"
                  to="/billing-section"
                >
                  {" "}
                  ← Back to Billing
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShowBillingPage;
